import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React from "react";

const FlowImg = require("../../Assets/Images/Flow.png");
const LatoRegular = require("../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    display: "flex",
    fontFamily: "Lato",
    padding: "20px",
    alignItems: "center",
  },
  coverTitle: {
    marginBottom: "10px",
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "30px",
    color: "#426B88",
    fontFamily: "Lato",
    textAlign: "center",
  },
  contentContainer: {
    textAlign: "center",
    maxWidth: "800px",
    marginTop: "10px",
  },
  paragraph: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "justify",
    marginBottom: "10px",
    marginTop: "5px",
  },
  secondsection: {
    width: "100%",
    flexDirection: "column",
    marginLeft: "110px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  coverImage: {
    width: "280px", 
    height: "330px",
    justifyContent: "center",
    alignContent: "center",
    marginVertical: "10px",
  },
  text: {
    fontWeight: "700",
    fontSize: "20px",
    lineHeight: "18px",
    color: "#426B88",
    fontFamily: "Lato",
    textAlign: "center",
    marginBottom: "10px",
    marginTop: "5px",
  },
  longtext: {
    fontWeight: "700",
    fontSize: "17px",
    fontFamily: "Lato",
    lineHeight: "18px",
    color: "#426B88",
    textAlign: "center",
    marginBottom: "10px",
    marginTop: "5px",
  }
});

const GroupQuadrantFlowFirstPage = () => {
  return (
    <View style={styles.coverSection}>
      <Text style={styles.coverTitle}>GROUP QUADRANT FLOW</Text>
      <View style={styles.contentContainer}>
        <Text style={styles.paragraph}>
          Quadrant Flow is a concept in personal and professional development
          that focuses on the movement of energy from one primary
          quadrant—Heart, Soul, Mind, and Strength—to the others, providing a
          holistic view of personality. Unlike traditional assessments that box
          individuals into fixed types, Quadrant Flow emphasizes the fluidity of
          personality, showing that everyone has aspects of all four quadrants.
        </Text>
        <Text style={styles.paragraph}>
          The journey through these quadrants offers insights into personal
          growth paths, highlighting that our so-called weaknesses or blind
          spots, represented by the last quadrant we flow into, are actually
          opportunities for learning and development. This approach encourages a
          more balanced and comprehensive self-awareness by recognizing
          potential growth areas rather than deficiencies.
        </Text>
        <View style={styles.secondsection}>
          <Text style={styles.text} >GROUP</Text>
          <Image src={FlowImg} style={styles.coverImage} />
          <Text style={styles.longtext}>YOU FLOW FROM HEART TO SOUL</Text>
        </View>
      </View>
    </View>
  );
};

export default GroupQuadrantFlowFirstPage;
